export default __webpack_public_path__ + "static/fire_extinguisher_w.f14a7931d320b637e35c727633b9ea44.png";